import { render } from "./AppSettingsSync.vue?vue&type=template&id=715a3792&scoped=true"
import script from "./AppSettingsSync.vue?vue&type=script&lang=js"
export * from "./AppSettingsSync.vue?vue&type=script&lang=js"

import "./AppSettingsSync.vue?vue&type=style&index=0&id=715a3792&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715a3792"]])

export default __exports__